import Vue from 'vue'
import Instance from './instance'
let Creator = Vue.extend(Instance)
let instances = []
const confirm = function (conf = {
  mainText: '',
  subText: '',
  showCancel: true,
  confirmBtnText: '确定',
  cancelBtnText: '取消',
  cancelFirst: false,
  onOk: () => {},
  onCancel: () => {}
}) {
  if (typeof window === 'undefined') return
  let instance = new Creator({
    propsData: {
      mainText: conf.mainText,
      subText: conf.subText,
      width: conf.width,
      showCancel: conf.showCancel,
      confirmBtnText: conf.confirmBtnText,
      cancelBtnText: conf.cancelBtnText
    }
  })
  instance.$mount()
  document.body.appendChild(instance.$el)
  instance.$on('close', () => {
    instances.shift()
    document.body.removeChild(instance.$el)
    conf.onCancel()
  })
  instance.$on('ok', () => {
    instances.shift()
    document.body.removeChild(instance.$el)
    conf.onOk()
  })
  instances.push(instance)
}
export default confirm
